<div class="vacancies-list">
  <!-- Hero -->
  <div class="vacancies-list__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'vacancies.list.hero_title' | translate }}</h1>
      <div class="vacancies-list__match-info">
        <p class="vacancy-hero__subtitle">{{ 'vacancies.list.hero_subtitle' | translate }}</p>
        <span
          class="vacancies-list__tooltip-trigger"
          (mouseenter)="showMatchTooltip = true"
          (mouseleave)="showMatchTooltip = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          <div class="vacancies-list__tooltip" *ngIf="showMatchTooltip">
            <div>
              <strong>{{ 'vacancies.list.tooltip_work_experience' | translate }}</strong>
              {{ 'vacancies.list.tooltip_work_experience_desc' | translate }}
            </div>
            <div>
              <strong>{{ 'vacancies.list.tooltip_dream_jobs' | translate }}</strong>
              {{ 'vacancies.list.tooltip_dream_jobs_desc' | translate }}
            </div>
            <div>
              <strong>{{ 'vacancies.list.tooltip_skills' | translate }}</strong>
              {{ 'vacancies.list.tooltip_skills_desc' | translate }}
            </div>
          </div>
        </span>
      </div>
      <div class="vacancies-list__basis-buttons">
        <button
          [class.active]="matchBasis === searchMode.ByWorkExperience"
          (click)="onMatchBasisChange(searchMode.ByWorkExperience)"
        >
          {{ 'vacancies.list.match_work_experience' | translate }}
        </button>
        <button
          [class.active]="matchBasis === searchMode.ByDreamProfessions"
          (click)="onMatchBasisChange(searchMode.ByDreamProfessions)"
        >
          {{ 'vacancies.list.match_dream_jobs' | translate }}
        </button>
        <button
          [class.active]="matchBasis === searchMode.SurpriseMe"
          (click)="onMatchBasisChange(searchMode.SurpriseMe)"
        >
          {{ 'vacancies.list.match_skills' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Search bar -->
  <div class="vacancies-list__search-bar">
    <div class="vacancy-container">
      <div class="vacancies-list__search-inner">
        <bwc-city-input
          class="vacancies-list__search-input pl-0"
          [control]="locationControl"
          [placeholder]="'vacancies.list.location_placeholder' | translate"
        ></bwc-city-input>
        <div class="vacancies-list__distance">
          <input
            type="range"
            [min]="0"
            [max]="distanceSteps.length - 1"
            [step]="1"
            [value]="distanceSliderValue"
            class="vacancies-list__range"
            (input)="onDistanceSliderChange($any($event.target).value)"
          />
          <span class="vacancies-list__distance-label">{{ distanceLabel }}</span>
        </div>
        <button
          type="button"
          class="vacancies-list__filter-toggle"
          [class.has-active]="activeFilterCount > 0"
          [class.is-open]="filterPanelOpen"
          [attr.aria-expanded]="filterPanelOpen"
          [attr.aria-label]="'vacancies.list.filter_button' | translate"
          (click)="toggleFilterPanel()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
          </svg>
          <span class="vacancies-list__filter-toggle-label">{{ 'vacancies.list.filter_button' | translate }}</span>
          <span class="vacancies-list__filter-toggle-badge" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
        </button>
        <button class="vacancies-list__search-btn" (click)="onMatchBasisChange(matchBasis)">
          {{ 'shared.search' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Filters bar -->
  <div class="vacancies-list__filters-bar" *ngIf="filterPanelOpen">
    <div class="vacancy-container">
      <div class="vacancies-list__filters">
        <div class="vacancies-list__filter-field">
          <label class="vacancies-list__filter-label">{{ 'vacancies.list.filter_field_of_work' | translate }}</label>
          <lib-single-select-search
            class="vacancies-list__filter-select"
            [options]="fieldOfWorkOptions"
            [control]="fieldOfWorkControl"
            [placeholder]="'vacancies.list.filter_all_fields' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onFieldOfWorkSelected($event)"
          ></lib-single-select-search>
        </div>
        <div class="vacancies-list__filter-field">
          <label class="vacancies-list__filter-label">{{ 'vacancies.list.filter_education' | translate }}</label>
          <lib-single-select-search
            class="vacancies-list__filter-select"
            [options]="educationOptions"
            [control]="educationControl"
            [placeholder]="'vacancies.list.filter_all_levels' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onEducationSelected($event)"
          ></lib-single-select-search>
        </div>
        <div class="vacancies-list__filter-field">
          <label class="vacancies-list__filter-label">{{ 'vacancies.list.filter_hours' | translate }}</label>
          <lib-single-select-search
            class="vacancies-list__filter-select"
            [options]="hoursOptions"
            [control]="hoursControl"
            [placeholder]="'vacancies.list.filter_all_hours' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onHoursSelected($event)"
          ></lib-single-select-search>
        </div>
        <div class="vacancies-list__filter-field">
          <label class="vacancies-list__filter-label">{{ 'vacancies.list.filter_posted' | translate }}</label>
          <lib-single-select-search
            class="vacancies-list__filter-select"
            [options]="postedOptions"
            [control]="postedControl"
            [placeholder]="'vacancies.list.filter_all_dates' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onPostedSelected($event)"
          ></lib-single-select-search>
        </div>
        <div class="vacancies-list__filter-field">
          <label class="vacancies-list__filter-label">{{ 'vacancies.list.sort_button' | translate }}</label>
          <lib-single-select-search
            class="vacancies-list__filter-select"
            [options]="sortOptionsList"
            [control]="sortControl"
            [placeholder]="'vacancies.list.sort_button' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onSortSelected($event)"
          ></lib-single-select-search>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="vacancies$ | async as vacancies">
    <!-- Loading -->
    <div class="vacancy-container vacancies-list__loading" *ngIf="loading && vacancies.length === 0">
      <p>{{ 'vacancies.loading' | translate }}...</p>
    </div>

    <!-- Error state -->
    <div class="vacancy-container vacancies-list__empty" *ngIf="!loading && vacancies.length === 0 && errorMessage">
      <div class="vacancies-list__warning">{{ errorMessage }}</div>
    </div>

    <!-- Empty state -->
    <div class="vacancy-container vacancies-list__empty" *ngIf="!loading && vacancies.length === 0 && !errorMessage">
      <p>{{ 'search.no_results' | translate }}</p>
    </div>

    <!-- Grid -->
    <div class="vacancy-container vacancies-list__content" *ngIf="vacancies.length > 0">
      <div class="vacancy-grid">
        <bwc-vacancy-card
          *ngFor="let vacancy of vacancies"
          [vacancy]="vacancy"
          [isLiked]="isLiked(vacancy)"
          [searchMode]="matchBasis"
          (liked)="toggleLike($event)"
          (cardClick)="openDetail($event)"
        ></bwc-vacancy-card>
      </div>

      <div #endOfList class="vacancy-load-more" *ngIf="hasMore$ | async">
        <p *ngIf="loading">{{ 'shared.loading' | translate }}...</p>
      </div>
    </div>
  </ng-container>

  <bwc-vacancy-detail *ngIf="detailData" [data]="detailData" (closed)="closeDetail()"></bwc-vacancy-detail>
</div>
